<template>
  <div v-if="loading" class="loading">
    <font-awesome-icon spin icon="circle-notch" />
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss">
@import "src/assets/css/variables.scss";
.loading {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 699999;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  svg {
    color: $blue;
    font-size: 4rem;
  }
}
</style>
